<template>
  <v-col class="pa-0">
    <sidebar-summary-row
      v-for="item of items"
      :key="item.name"
      v-bind="item"
      :checkboxes-values="checkboxesValues"
      @updateCheckboxesValues="updateCheckboxesValues"
    >
      <template v-for="(value, key) in $scopedSlots" #[key]="scope">
        <slot :name="key" v-bind="scope" />
      </template>
    </sidebar-summary-row>
  </v-col>
</template>

<script>
import SidebarSummaryRow from '@/components/SidebarSummaryRow';

export default {
  name: 'SidebarSummary',
  components: {
    SidebarSummaryRow,
  },
  props: {
    checkboxesValues: {
      type: Array,
      default: () => {
        return [];
      },
    },
    items: {
      type: Array,
      defult: () => [],
    },
  },
  methods: {
    updateCheckboxesValues(nV) {
      this.$emit('updateCheckboxesValues', nV);
    },
  },
};
</script>
